module.exports = __webpack_public_path__ + "static/media/kevllar-logo-color-180@2x.59458b93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/kevllar-logo-color-180@2x.png
// module id = 483
// module chunks = 0